<template>
  <div id="app">
    <!--
    <keep-alive v-if="$route.meta.keepAlive">
        <router-view></router-view>
    </keep-alive>
    <router-view v-else></router-view>
    -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
    export default {
        data () {
            return {}
        }
    }
</script>

<style lang="less">
@import "./styles/reset.css";
.ellipsis {
    white-space: nowrap;
    text-overflow: ellipsis;
    word-wrap: normal;
    overflow: hidden;
}
.ellipsis(@line) {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: @line;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
//   background-color: #efeff4;
  color: #2c3e50;
  .main {
      background-color: #fff;
  }
  @media (min-width: 1025px) {
    .main {
        max-width: 750PX;
    }
}
  .info-box {
    background-color: #fff;
    &.blue {
      background-image: url(assets/header-bg-blue.png);
      background-repeat: no-repeat;
      background-position-y: -40px;
      background-size: cover;
    }
    &.green {
      background-image: url(assets/header-bg-green.png);
      background-repeat: no-repeat;
      background-position-y: -40px;
      background-size: cover;
    }
  }
  .baseline {
    background-color: #f7f7f7;
    font-family: PingFang-SC-Medium;
    font-size: 20px;
    line-height: 120px;
    color: #b3b3b3;
    text-align: center;
  }
  .swipe-box {
      padding: 25px 0 40px;
      .van-swipe-item {
          padding: 0 .133333rem;
          &:first-child {
              padding-left: .4rem;
          }
          &:last-child {
              padding-right: .4rem;
          }
          .content-box {
              padding: .4rem .4rem .48rem;
              width: 100%;
              height: 100%;
              border-radius: .133333rem;
              border: 1PX solid #f0f0f0;
              .title {
                  font-family: PingFang-SC-Bold;
                  font-size: .426667rem;
                  line-height: .48rem;
                  color: #000000;
              }
              .box {
                  display: flex;
                  padding-top: .453333rem;
                  width: 100%;
                  &-item {
                      flex: 1;
                      &.count {
                          padding-top: .2rem;
                          text-align: center;
                          .t {
                              font-family: PingFang-SC-Medium;
                              font-size: .293333rem;
                              line-height: .48rem;
                              color: #666666;
                          }
                          .num {
                              margin-top: .066667rem;
                              font-family: Bahnschrift;
                              font-size: 1.013333rem;
                              color: #000000;
                              span {
                                  font-family: PingFang-SC-Medium;
                                  font-size: .346667rem;
                                  line-height: .48rem;
                                  color: #000000;
                              }
                          }
                      }
                  }
              }
          }
          &:nth-child(2n-1) .content-box {
              background-color: #f2fbfe;
          }
          &:nth-child(2n) .content-box {
              background-color: #f2fefb;
          }
      }
  }
}
</style>
